import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import moment from "moment";
import { OrganizationDateRangeFilterEnum, ResolutionsEnum } from "utils/Enums";
export var ChartMetrics = {
  occupancy: {
    value: "occupancy",
    label: "Occupancy",
    dataFieldName: "overallOccupancyPercentage",
    chartAverageFieldName: "chartAverageOccupancy"
  },
  utilization: {
    value: "utilization",
    label: "Utilization",
    dataFieldName: "overallUtilizationPercentage",
    chartAverageFieldName: "chartAverageUtilization"
  }
};
export var StatsCategory = {
  department: {
    value: "department",
    label: "Department"
  },
  work_mode: {
    value: "work_mode",
    label: "Work mode"
  },
  commute: {
    value: "commute",
    label: "Commute"
  }
};
export var LowestResolutionBasedOnDateRange = function LowestResolutionBasedOnDateRange(dateRange) {
  var lowestDailyDateRanges = [OrganizationDateRangeFilterEnum.LAST_7_DAYS.value, OrganizationDateRangeFilterEnum.LAST_WEEK.value, OrganizationDateRangeFilterEnum.LAST_MONTH.value];
  var lowestWeeklyDateRanges = [OrganizationDateRangeFilterEnum.LAST_QUARTER.value, OrganizationDateRangeFilterEnum.THIS_YEAR.value, OrganizationDateRangeFilterEnum.LAST_YEAR.value];
  if (_includesInstanceProperty(lowestWeeklyDateRanges).call(lowestWeeklyDateRanges, dateRange)) {
    return ResolutionsEnum.WEEK.value;
  } else if (_includesInstanceProperty(lowestDailyDateRanges).call(lowestDailyDateRanges, dateRange)) {
    return ResolutionsEnum.DAY.value;
  }
  return ResolutionsEnum.DAY.value;
};
export var CalculateMinMaxDate = function CalculateMinMaxDate(dateRange) {
  if (dateRange === OrganizationDateRangeFilterEnum.LAST_7_DAYS.value) {
    return {
      minDate: moment().subtract(1, "weeks"),
      maxDate: moment()
    };
  } else if (dateRange === OrganizationDateRangeFilterEnum.LAST_WEEK.value) {
    return {
      minDate: moment().subtract(1, "weeks").startOf("week"),
      maxDate: moment().subtract(1, "weeks").endOf("week")
    };
  } else if (dateRange === OrganizationDateRangeFilterEnum.LAST_MONTH.value) {
    return {
      minDate: moment().subtract(1, "months").startOf("month"),
      maxDate: moment().subtract(1, "months").endOf("month")
    };
  } else if (dateRange === OrganizationDateRangeFilterEnum.LAST_QUARTER.value) {
    return {
      minDate: moment().subtract(1, "quarter").startOf("quarter"),
      maxDate: moment().subtract(1, "quarter").endOf("quarter")
    };
  } else if (dateRange === OrganizationDateRangeFilterEnum.THIS_YEAR.value) {
    return {
      minDate: moment().startOf("year"),
      maxDate: moment()
    };
  } else if (dateRange === OrganizationDateRangeFilterEnum.LAST_YEAR.value) {
    return {
      minDate: moment().subtract(1, "year").startOf("year"),
      maxDate: moment().subtract(1, "year").endOf("year")
    };
  }
  return {
    minDate: moment().startOf("year"),
    maxDate: moment()
  };
};
/*  Returns Data in a format that can be parsed by the ReCharts Bar Chart
    
    returns a list of data to render in the Bar Chart
        [
            { 
                date,
                overallOccupancyPercentage0,
                overallUtilizationPercentage0,
                overallOccupancyPercentage1,
                overallUtilizationPercentage1,
                ... // Index is appended to end to differentiate between bars
                leases: [ // This array is not used on bar, but used to render the popovers
                    leaseName
                    overallOccupancyPercentage
                    overallUtilizationPercentage
                ]
            }
        ]
*/
export var formatLeaseComparisonChartData = function formatLeaseComparisonChartData(leases, leasesToInclude) {
  var _context;
  var resolutionAnalytics = {};
  var extractLeaseAnalyticsData = function extractLeaseAnalyticsData(lease) {
    var _lease$workplace$reso, _lease$workplace;
    var leaseAnalyticsData = (_lease$workplace$reso = lease === null || lease === void 0 || (_lease$workplace = lease.workplace) === null || _lease$workplace === void 0 ? void 0 : _lease$workplace.resolutionAnalytics) !== null && _lease$workplace$reso !== void 0 ? _lease$workplace$reso : [];
    var leaseName = lease === null || lease === void 0 ? void 0 : lease.leaseName;
    _forEachInstanceProperty(leaseAnalyticsData).call(leaseAnalyticsData, function (element) {
      var date = element.date;
      var leaseData = {
        leaseName: leaseName,
        overallOccupancyPercentage: element.overallOccupancyPercentage,
        overallUtilizationPercentage: element.overallUtilizationPercentage
      };
      if (date in resolutionAnalytics) {
        resolutionAnalytics[date].leases.push(leaseData);
      } else {
        resolutionAnalytics[date] = {
          date: element.date,
          leases: [leaseData]
        };
      }
    });
  };
  leases === null || leases === void 0 || _forEachInstanceProperty(leases).call(leases, function (lease) {
    if (_includesInstanceProperty(leasesToInclude).call(leasesToInclude, lease === null || lease === void 0 ? void 0 : lease.id)) {
      extractLeaseAnalyticsData(lease);
    }
  });

  // https://recharts.org/en-US/api/BarChart#data
  // The ReCharts Data needs to be in the following format:
  // [{ name: 'a', value: 1 }]
  _forEachInstanceProperty(_context = _Object$entries(resolutionAnalytics)).call(_context, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      date = _ref2[0],
      values = _ref2[1];
    var leases = values === null || values === void 0 ? void 0 : values.leases;
    _forEachInstanceProperty(leases).call(leases, function (lease, index) {
      var overallOccupancyPercentage = lease.overallOccupancyPercentage;
      var overallUtilizationPercentage = lease.overallUtilizationPercentage;
      resolutionAnalytics[date]["overallOccupancyPercentage".concat(index)] = overallOccupancyPercentage;
      resolutionAnalytics[date]["overallUtilizationPercentage".concat(index)] = overallUtilizationPercentage;
    });
  });
  return _Object$values(resolutionAnalytics);
};
export var CalculateChartReferenceLineAverage = function CalculateChartReferenceLineAverage(data, chartMetric) {
  if ((data === null || data === void 0 ? void 0 : data.length) === 0) {
    return null;
  }
  var sum = data === null || data === void 0 ? void 0 : _reduceInstanceProperty(data).call(data, function (acc, next) {
    var _next$leases;
    var innerSum = next === null || next === void 0 || (_next$leases = next.leases) === null || _next$leases === void 0 ? void 0 : _reduceInstanceProperty(_next$leases).call(_next$leases, function (innerAcc, innerNext) {
      var dataFieldName = ChartMetrics[chartMetric].dataFieldName;
      return innerAcc + (innerNext === null || innerNext === void 0 ? void 0 : innerNext[dataFieldName]);
    }, 0);
    return acc + innerSum;
  }, 0);
  var count = _reduceInstanceProperty(data).call(data, function (acc, next) {
    var _next$leases2;
    return acc + (next === null || next === void 0 || (_next$leases2 = next.leases) === null || _next$leases2 === void 0 ? void 0 : _next$leases2.length);
  }, 0);
  var average = sum / count;
  return average;
};
export var CalculateComparisonChartMax = function CalculateComparisonChartMax(data, chartMetric) {
  var dataFieldName = ChartMetrics[chartMetric].dataFieldName;
  var max = _reduceInstanceProperty(data).call(data, function (max, next) {
    var _next$leases3;
    var innerMax = next === null || next === void 0 || (_next$leases3 = next.leases) === null || _next$leases3 === void 0 ? void 0 : _reduceInstanceProperty(_next$leases3).call(_next$leases3, function (innerMax, innerNext) {
      return (innerNext === null || innerNext === void 0 ? void 0 : innerNext[dataFieldName]) > innerMax ? innerNext === null || innerNext === void 0 ? void 0 : innerNext[dataFieldName] : innerMax;
    }, 0);
    return innerMax > max ? innerMax : max;
  }, 0);
  return max;
};
export var PopOverDateHelper = function PopOverDateHelper(date, resolution) {
  if (resolution === ResolutionsEnum.DAY.value) {
    return moment(date).format("MMM D, YYYY");
  } else if (resolution === ResolutionsEnum.WEEK.value) {
    var _context2;
    var WeeksFriday = moment(date).day("friday");
    return _concatInstanceProperty(_context2 = "".concat(moment(date).format("MMM D"), " - ")).call(_context2, WeeksFriday.format("D, YYYY"), " ");
  } else if (resolution === ResolutionsEnum.MONTH.value) {
    return moment(date).format("MMM YYYY");
  } else if (resolution === ResolutionsEnum.QUARTER.value) {
    return "Q".concat(moment(date).format("Q, YYYY"));
  }
  return "unexpected resolution";
};
export var AnalyticsOverviewDateRangeHelper = function AnalyticsOverviewDateRangeHelper(dateRange) {
  var minMaxDates = CalculateMinMaxDate(dateRange);
  var minDate = minMaxDates.minDate;
  var maxDate = minMaxDates.maxDate;
  if (dateRange === OrganizationDateRangeFilterEnum.LAST_7_DAYS.value) {
    var _context3;
    return _concatInstanceProperty(_context3 = "".concat(moment(minDate).format("MMM D"), " - ")).call(_context3, maxDate.format("D, YYYY"), " ");
  } else if (dateRange === OrganizationDateRangeFilterEnum.LAST_WEEK.value) {
    var _context4;
    return _concatInstanceProperty(_context4 = "".concat(moment(minDate).format("MMM D"), " - ")).call(_context4, maxDate.format("D, YYYY"), " ");
  } else if (dateRange === OrganizationDateRangeFilterEnum.LAST_MONTH.value) {
    return moment(minDate).format("MMM YYYY");
  } else if (dateRange === OrganizationDateRangeFilterEnum.LAST_QUARTER.value) {
    return "Q".concat(moment(minDate).format("Q, YYYY"));
  } else if (dateRange === OrganizationDateRangeFilterEnum.THIS_YEAR.value) {
    return "".concat(moment(minDate).format("YYYY"));
  } else if (dateRange === OrganizationDateRangeFilterEnum.LAST_YEAR.value) {
    return "".concat(moment(minDate).format("YYYY"));
  }
  return "unexpected date range";
};